<template>
    <div>
        <NavPage></NavPage>
        <div class="content">
            <SlideShow></SlideShow>
        </div>
        <SolutionCenter></SolutionCenter>
        <FooterPage></FooterPage>
    </div>
</template>

<script>
import NavPage from '@/components/NavPage.vue'
import SlideShow from '@/components/SlideShow.vue'
import FooterPage from '@/components/FooterPage.vue'
import SolutionCenter from '@/components/SolutionCenter.vue'
export default {
    name: 'SolutionPage',
    components: {
        NavPage,
        SlideShow,
        FooterPage,
        SolutionCenter
    }
}
</script>

<style scoped>
.content {
  width: 1340px;
  margin: auto;
}
</style>
